/* eslint-disable no-unused-vars */
/* eslint-disable no-return-await */
/* eslint-disable no-param-reassign */
import axios from 'axios'
// import Vue from 'vue'
const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      items: [],
      data: [],
      countAll: 0,
      countAllDetail: 0,
      current: 0,
      success: 0,
      failed: 0,
      runningState: false,
      cancelToken: '',
   },
   getters: {},
   actions: {
      async getData({ commit, rootState }) {
         rootState.isLoading = true
         return await axios.get(`${baseURL}oss/scrap/izin`).then(
            response => {
               commit('SET_DATA', response.data.items)
               commit('SET_COUNT', response.data.items)
               commit('SET_COUNT_DETAIL', response.data.itemDetail)
               rootState.isLoading = false
               return Promise.resolve(response.data.items)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      async getDataError({ commit, rootState }) {
         rootState.isLoading = true
         return await axios.get(`${baseURL}oss/scrap/izin/error`).then(
            response => {
               commit('SET_DATA', response.data.items)
               commit('SET_COUNT', response.data.items)
               commit('SET_COUNT_DETAIL', response.data.itemDetail)
               rootState.isLoading = false
               return Promise.resolve(response.data.items)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      async getNib({ commit, rootState }, param) {
         rootState.isLoading = true
         return await axios.get(`${baseURL}oss/scrap/izin/nib?id_permohonan_izin=${param.id_permohonan_izin}&id_proyek=${param.id_proyek}`).then(
            response => {
               rootState.isLoading = false
               return Promise.resolve(response.data)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      runScrap({ commit, rootState, state }, param) {
         rootState.isLoading = true
         // const param = { nib }
         return axios
            .post(`${baseURL}oss/scrap/izin`, param, {
               cancelToken: state.cancelToken,
            })
            .then(
               res => {
                  commit('SET_SUCCESS')
                  commit('NEXT')
                  rootState.isLoading = false
                  return Promise.resolve(res)
               },
               error => {
                  commit('SET_FAILED')
                  commit('NEXT')
                  rootState.isLoading = false
                  return Promise.resolve(error)
               },
            )
      },
      async runScrapPermohonan({ rootState, state }, page) {
         rootState.isLoading = true
         return axios
            .post(
               `${baseURL}oss/scrap/izin/updatelist`,
               { page },
               {
                  cancelToken: state.cancelToken,
               },
            )
            .then(
               response => {
                  rootState.isLoading = false
                  return Promise.resolve(response.data)
               },
               () => {
                  rootState.isLoading = false
                  return Promise.reject()
               },
            )
      },
      runLogin({ rootState }) {
         rootState.isLoading = true
         return axios.post(`${baseURL}oss/scrap/login`).then(
            response => {
               rootState.isLoading = false
               return Promise.resolve(response.data)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data
      },
      SET_DATA_TABLE(state, data) {
         state.items = data
      },
      SET_COUNT(state, data) {
         state.countAll = data.length
      },
      SET_COUNT_DETAIL(state, data) {
         state.countAllDetail = data
      },
      SET_COUNT_TABLE(state, data) {
         state.countAll = data
      },
      SET_CURRENT(state, data) {
         state.current = data
      },
      SET_SUCCESS(state) {
         state.success += 1
      },
      SET_FAILED(state) {
         state.failed += 1
      },
      SET_STATE(state, data) {
         state.runningState = data
      },
      SET_CANCEL_TOKEN(state, data) {
         state.cancelToken = data
      },
      NEXT(state) {
         state.current += 1
      },
      SET_RESET(state) {
         state.current = 0
         state.success = 0
         state.failed = 0
      },
   },
}
